var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 21152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40433",
    d: "M6.83228 1C6.83228 0.723858 7.05613 0.5 7.33228 0.5C7.60842 0.5 7.83228 0.723858 7.83228 1V11C7.83228 11.2761 7.60842 11.5 7.33228 11.5C7.05613 11.5 6.83228 11.2761 6.83228 11V1Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40434",
    d: "M9.61157 1C9.61157 0.723858 9.83543 0.5 10.1116 0.5C10.3877 0.5 10.6116 0.723858 10.6116 1V11C10.6116 11.2761 10.3877 11.5 10.1116 11.5C9.83543 11.5 9.61157 11.2761 9.61157 11V1Z",
    fill: "#8A8A8A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 21151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40433_2",
    d: "M2.83301 6C2.83301 5.72386 3.05687 5.5 3.33301 5.5C3.60915 5.5 3.83301 5.72386 3.83301 6V11C3.83301 11.2761 3.60915 11.5 3.33301 11.5C3.05687 11.5 2.83301 11.2761 2.83301 11V6Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 77",
    d: "M5.14985 3.52671C5.14985 4.94491 4.21481 5.92671 3.24985 5.92671C2.2849 5.92671 1.34985 4.94491 1.34985 3.52671C1.34985 2.09154 2.18419 1.12671 3.24985 1.12671C4.31552 1.12671 5.14985 2.09154 5.14985 3.52671Z",
    stroke: "#8A8A8A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeal);
export default __webpack_public_path__ + "static/media/meal.12a1cc75f7827efa0b40138ed089e51b.svg";
export { ForwardRef as ReactComponent };